<div class="user-not-has-licenses" *ngIf="licenses_table.length === 0 && !loading">
    <div class="container-landing">

        <div class="container-landing-title">
            <h2>{{ 'compass.greeting' | translate : { user_name: user_name } }}</h2>
        </div>

        <div class="container-landing-content">
            <h3>{{ 'compass.title' | translate }}</h3>
            <div class="container-landing-content-title"> 
                <div class="container-landing-content-title-title">
                    <h2>{{ 'compass.subtitle.discover' | translate }}</h2>
                    <h2><strong>{{ 'compass.subtitle.automate' | translate }}</strong></h2>
    
                    <p [innerHTML]="'compass.description' | translate"></p>
                    <button mat-button [routerLink]="['/dashboard/company/compass/buy']">{{ 'compass.hire' | translate }}</button>
                </div>
                <div class="container-landing-content-title-image">
                    <img src="assets/img-landing-1.png" alt="Compass Landing">
                </div>
            </div>
        </div>

        <div class="container-landing-content-image">
            <img src="assets/img-landing-2.png" alt="Compass Landing"> 
        </div>
    
        
        
        <div class="container-landing-content-2 container-landing-content">
            <h3>{{ 'compass.expertPartner' | translate }}</h3>
    
            <div class="container-content-info">
                <div class="container-content-info-item">
                    <img src="assets/compass/items-expert/time.png" alt="Compass Landing">
                    <div class="container-content-info-item-title">
                        <h4>{{ 'compass.features.saveTime.title' | translate }}</h4>
                        <p>{{ 'compass.features.saveTime.description' | translate }}</p>
                    </div>
                </div>
                <div class="container-content-info-item">
                    <img src="assets/compass/items-expert/meet.png" alt="Compass Landing">
                    <div class="container-content-info-item-title">
                        <h4>{{ 'compass.features.knowPerson.title' | translate }}</h4>
                        <p>{{ 'compass.features.knowPerson.description' | translate }}</p>
                    </div>
                </div>
    
                <div class="container-content-info-item">
                    <img src="assets/compass/items-expert/potencial.png" alt="Compass Landing">
                    <div class="container-content-info-item-title">
                        <h4>{{ 'compass.features.fitPotential.title' | translate }}</h4>
                        <p>{{ 'compass.features.fitPotential.description' | translate }}</p>
                    </div>
                </div>
                <div class="container-content-info-item">
                    <img src="assets/compass/items-expert/potential.png" alt="Compass Landing">
                    <div class="container-content-info-item-title">
                        <h4>{{ 'compass.features.chooseCriteria.title' | translate }}</h4>
                        <p>{{ 'compass.features.chooseCriteria.description' | translate }}</p>
                    </div>
                </div>
                <div class="container-content-info-item">
                    <img src="assets/compass/items-expert/expert.png" alt="Compass Landing">
                    <div class="container-content-info-item-title">
                        <h4>{{ 'compass.features.hrExpert.title' | translate }}</h4>
                        <p>{{ 'compass.features.hrExpert.description' | translate }}</p>
                    </div>
                </div>
                <div class="container-content-info-item">
                    <img src="assets/compass/items-expert/security.png" alt="Compass Landing"> 
                    <div class="container-content-info-item-title">
                        <h4>{{ 'compass.features.hireSecurity.title' | translate }}</h4>
                        <p>{{ 'compass.features.hireSecurity.description' | translate }}</p>
                    </div>
                </div>
            </div>
        </div>
    
        <div class="container-landing-content" style="display:block !important">
            <div class="container-landing-content-title"> 
                <div class="container-landing-content-title-title">
                    <h2>{{ 'compass.resume.title' | translate }}</h2>
                    <h2><strong>{{ 'compass.resume.subtitle' | translate }}</strong></h2>
                    <p [innerHTML]="'compass.resume.description' | translate"></p>
                </div>
            </div>
            <div class="container-landing-content-extension">
                <img src="assets/compass/portatil-extension.png" alt="Compass Landing">
                <div class="container-content-extension-items">
                    <div class="container-content-info-item">
                        <img src="assets/compass/item-1.png" alt="Compass Landing">
                        <div class="container-content-info-item-title">
                            <h4>{{ 'compass.resume.items.languages.title' | translate }}</h4>
                            <p>{{ 'compass.resume.items.languages.description' | translate }}</p>
                        </div>
                    </div>
                    <div class="container-content-info-item">
                        <img src="assets/compass/item-2.png" alt="Compass Landing">
                        <div class="container-content-info-item-title">
                            <h4>{{ 'compass.resume.items.experience.title' | translate }}</h4>
                            <p>{{ 'compass.resume.items.experience.description' | translate }}</p>
                        </div>
                    </div>
                    <div class="container-content-info-item">
                        <img src="assets/compass/item-3.png" alt="Compass Landing">
                        <div class="container-content-info-item-title">
                            <h4>{{ 'compass.resume.items.sectors.title' | translate }}</h4>
                            <p>{{ 'compass.resume.items.sectors.description' | translate }}</p>
                        </div>
                    </div>
                    <div class="container-content-info-item">
                        <img src="assets/compass/item-4.png" alt="Compass Landing"> 
                        <div class="container-content-info-item-title">
                            <h4>{{ 'compass.resume.items.companyTypes.title' | translate }}</h4>
                            <p>{{ 'compass.resume.items.companyTypes.description' | translate }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
    
        <div class="container-landing-content" style="display:block !important">
            <div class="container-landing-content-title"> 
                <div class="container-landing-content-title-title">
                    <h2>{{ 'compass.personalityDetection.title' | translate }}</h2>
                    <h2><strong>{{ 'compass.personalityDetection.subtitle' | translate }}</strong></h2>
                    <p [innerHTML]="'compass.personalityDetection.description' | translate"></p>
                </div>
            </div>
            <div class="container-landing-content-extension">
                <div class="container-content-extension-items">
                <div class="container-content-info-item">
                    <img src="assets/compass/items-expert/time.png" alt="Compass Landing">
                    <div class="container-content-info-item-title">
                        <h4>{{ 'compass.personalityItems.traits.title' | translate }}</h4>
                        <p>{{ 'compass.personalityItems.traits.description' | translate }}</p>
                    </div>
                </div>
                <div class="container-content-info-item">
                    <img src="assets/compass/items-expert/meet.png" alt="Compass Landing">
                    <div class="container-content-info-item-title">
                        <h4>{{ 'compass.personalityItems.cultureFit.title' | translate }}</h4>
                        <p>{{ 'compass.personalityItems.cultureFit.description' | translate }}</p>
                    </div>
                </div>
                <div class="container-content-info-item">
                    <img src="assets/compass/items-expert/potential.png" alt="Compass Landing">
                    <div class="container-content-info-item-title">
                        <h4>{{ 'compass.personalityItems.risk.title' | translate }}</h4>
                        <p>{{ 'compass.personalityItems.risk.description' | translate }}</p>
                    </div>
                </div>
                <div class="container-content-info-item">
                    <img src="assets/compass/items-expert/expert.png" alt="Compass Landing">
                    <div class="container-content-info-item-title">
                        <h4>{{ 'compass.personalityItems.saveTime.title' | translate }}</h4>
                        <p>{{ 'compass.personalityItems.saveTime.description' | translate }}</p>
                    </div>
                </div>
            </div>
            <img src="assets/compass/portatil-personalidad.png" alt="Compass Landing">
        </div>

        <div class="container-landing-content" style="display:block !important">
            <div class="container-landing-content-title"> 
                <div class="container-landing-content-title-title">
                    <h2>{{ 'compass.aiAgent.title' | translate }}</h2>
                    <h2><strong>{{ 'compass.aiAgent.subtitle' | translate }}</strong></h2>
                    <p [innerHTML]="'compass.aiAgent.description' | translate"></p>
                </div>
            </div>
            <div class="container-landing-content-extension">
                <img src="assets/compass/portatil-chat.png" alt="Compass Landing">

                <div class="container-content-extension-items">
                    <div class="container-content-info-item">
                        <img src="assets/compass/item-1.png" alt="Compass Landing">
                        <div class="container-content-info-item-title">
                            <h4>{{ 'compass.aiAgent.items.evaluation.title' | translate }}</h4>
                            <p>{{ 'compass.aiAgent.items.evaluation.description' | translate }}</p>
                        </div>
                    </div>
                    <div class="container-content-info-item">
                        <img src="assets/compass/item-2.png" alt="Compass Landing">
                        <div class="container-content-info-item-title">
                            <h4>{{ 'compass.aiAgent.items.explanations.title' | translate }}</h4>
                            <p>{{ 'compass.aiAgent.items.explanations.description' | translate }}</p>
                        </div>
                    </div>
                    <div class="container-content-info-item">
                        <img src="assets/compass/item-3.png" alt="Compass Landing">
                        <div class="container-content-info-item-title">
                            <h4>{{ 'compass.aiAgent.items.interviewAssist.title' | translate }}</h4>
                            <p>{{ 'compass.aiAgent.items.interviewAssist.description' | translate }}</p>
                        </div>
                    </div>
                    <div class="container-content-info-item">
                        <img src="assets/compass/item-4.png" alt="Compass Landing"> 
                        <div class="container-content-info-item-title">
                            <h4>{{ 'compass.aiAgent.items.expert.title' | translate }}</h4>
                            <p>{{ 'compass.aiAgent.items.expert.description' | translate }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-landing-content-2 container-landing-content">
            <h3>{{ 'compass.benefits.title' | translate }} <br><strong>Conectio Compass</strong></h3>

            <div class="container-content-info-win">
                <div class="container-content-info-item-win">
                    <img src="assets/compass/unlock-talent.png" alt="Compass Landing">
                    <div class="container-content-info-item-title">
                        <h4 [innerHTML]="'compass.benefits.items.speed.title' | translate"></h4>
                        <p>{{ 'compass.benefits.items.speed.description' | translate }}</p>
                    </div>
                </div>
                <div class="container-content-info-item-win">
                    <img src="assets/compass/Recruitment.png" alt="Compass Landing">
                    <div class="container-content-info-item-title">
                        <h4 [innerHTML]="'compass.benefits.items.support.title' | translate"></h4>
                        <p>{{ 'compass.benefits.items.support.description' | translate }}</p>
                    </div>
                </div>
                <div class="container-content-info-item-win">
                    <img src="assets/compass/boosting-hiring.png" alt="Compass Landing">
                    <div class="container-content-info-item-title">
                        <h4 [innerHTML]="'compass.benefits.items.insights.title' | translate"></h4>
                        <p>{{ 'compass.benefits.items.insights.description' | translate }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-landing-pasos" >
            <h3>{{ 'compass.steps.title' | translate }}</h3>
            <div class="container-landing-pasos-items">
                <div class="container-landing-pasos-item">
                    <img src="assets/compass/plan-1.png" alt="Compass Landing">
                    <div class="container-landing-pasos-item-title">
                        <h4>{{ 'compass.steps.items.install.title' | translate }}</h4>
                        <p>{{ 'compass.steps.items.install.description' | translate }}</p>
                    </div>
                </div>
                <div class="container-landing-pasos-item">
                    <img src="assets/compass/plan-2.png" alt="Compass Landing">
                    <div class="container-landing-pasos-item-title">
                        <h4>{{ 'compass.steps.items.navigate.title' | translate }}</h4>
                        <p>{{ 'compass.steps.items.navigate.description' | translate }}</p>
                    </div>
                </div>
                <div class="container-landing-pasos-item">
                    <img src="assets/compass/plan-3.png" alt="Compass Landing">
                    <div class="container-landing-pasos-item-title">
                        <h4>{{ 'compass.steps.items.letDo.title' | translate }}</h4>
                        <p>{{ 'compass.steps.items.letDo.description' | translate }}</p>
                    </div>
                </div>
            </div> 
        </div>
    
        <div class="container-planes" >
            <h3 [innerHTML]="'compass.plans.title' | translate"></h3>
            <div class="container-planes-content">
                <div class="plan-card">
                    <h2 class="plan-card-title">{{ 'compass.plans.monthly.title' | translate }}</h2>
                    <p class="plan-card-price">{{ 'compass.plans.monthly.price' | translate }}</p>
                    <p class="plan-card-price-description" [innerHTML]="'compass.plans.monthly.description' | translate"></p>
                    <button mat-button [routerLink]="['/dashboard/company/compass/buy']">{{ 'compass.plans.monthly.button' | translate }}</button>
                </div>
                <div class="plan-card">
                    <h2 class="plan-card-title">{{ 'compass.plans.annual.title' | translate }}</h2>
                    <p class="plan-card-price">{{ 'compass.plans.annual.price' | translate }}</p>
                    <p class="plan-card-price-description" [innerHTML]="'compass.plans.annual.description' | translate"></p>
                    <button mat-button [routerLink]="['/dashboard/company/compass/buy']">{{ 'compass.plans.annual.button' | translate }}</button>
                </div>
            </div>
        </div>
    
        <div class="container-footer">
            <div class="container-footer-1">
                <div class="container-footer-item" style="width: 70%;">
                    <h2>{{ 'compass.contact.title' | translate }}</h2>
                    <p>{{ 'compass.contact.subtitle' | translate }}</p>
                    <form [formGroup]="contactForm">
                        <div class="form-group-initial">
                            <input type="text" [placeholder]="'compass.contact.name' | translate" formControlName="name" />
                            <input type="email" [placeholder]="'compass.contact.email' | translate" formControlName="email" />
                        </div>
                        <div class="form-group-initial" style="width: 100%;">
                            <input  type="text" [placeholder]="'compass.contact.message' | translate" formControlName="message" />
                        </div>
        
                        <label style="display: inline-flex; align-items: center; color: #f1f1f1;">
                            <input type="checkbox" style="margin-right: 8px; width:auto;" formControlName="terms" />
                            <span [innerHTML]="'compass.contact.privacyPolicy' | translate"></span>
                        </label>
        
                        <p *ngIf="text_message.message" [ngClass]="{'form-error-message': text_message.type == 'error', 'form-confirmation-message': text_message.type == 'success'}">{{text_message.message}}</p>
        
        
                        <button mat-button type="button" (click)="sendMessage()">{{ 'compass.contact.sendMessage' | translate }}</button>
                    </form>
                </div>
                <div class="container-footer-item" style="width: 30%;">
                    <h2>{{ 'compass.offices.title' | translate }}</h2>
                    <p>{{ 'compass.offices.subtitle' | translate }}</p>
                    <div class="container-footer-item-image">
                        <img src="assets/compass/pasador-de-ubicacion.png" alt="Compass Landing" class="img-footer">
                        <span class="container-footer-item-image-title">Conectio</span>
                    </div>
                    <p class="container-footer-text" [innerHTML]="'compass.offices.address' | translate">
                    </p>
                    <div class="container-footer-item-image">
                        <img src="assets/compass/llamar.png" alt="Compass Landing" class="img-footer">
                        <span class="container-footer-item-image-title">{{ 'compass.offices.phone' | translate }}</span>
                    </div>
                    <p class="container-footer-text">
                        {{ 'compass.offices.phoneNumbers' | translate }}
                    </p>
                    <div class="container-footer-item-image">
                        <img src="assets/compass/correo-electronico.png" alt="Compass Landing" class="img-footer">
                        <span class="container-footer-item-image-title">{{ 'compass.offices.businessInquiries' | translate }}</span>
                    </div>
                    <p class="container-footer-text" [innerHTML]="'compass.offices.email' | translate">
                    </p>
                </div>
            </div>
            <div class="container-footer-2">
                <img src="assets/logo-sidebar.png" alt="Compass Landing" class="img-footer-sidebar">
                <p>{{ 'compass.footer.tagline' | translate }}</p>
                <p>{{ 'footer.copyright' | translate }} {{ 'footer.company' | translate }}. {{ 'footer.rights' | translate }}</p>
                <p style="display: flex; gap: 10px; justify-content: center;">
                    <a href="https://conectio.io/legal-advise">{{ 'footer.legal.legalNotice' | translate }}</a>
                    <a href="https://conectio.io/cookie-policy">{{ 'footer.legal.cookiePolicy' | translate }}</a>
                    <a href="https://conectio.io/privacy-policy">{{ 'footer.legal.privacyPolicy' | translate }}</a>
                </p>
            </div>
        </div>
    </div>
</div>
</div>



<div class="user-has-licenses" *ngIf="licenses_table.length > 0 && !loading">
    <div class="table-container"> 
        <div class="container-landing-title">
            <h2>{{ 'compass.licenses.manageTitle' | translate }}</h2> 
        </div>
        <div class="container-email-validated" *ngIf="bought_licenses || assigned_licenses || deleted_licenses">
            <div class="container-email-validated-content" *ngIf="bought_licenses">
                <img src="assets/verified-mail-check.png" [alt]="'compass.licenses.alt.verifiedEmail' | translate">
                <span [innerHTML]="('compass.licenses.notifications.bought' | translate: { addedVerb: (quantity_bought_licenses > 1 ? ('compass.licenses.words.haveBeenAdded' | translate) : ('compass.licenses.words.hasBeenAdded' | translate)), quantity: quantity_bought_licenses, licenseWord: (quantity_bought_licenses > 1 ? ('compass.licenses.words.licenses' | translate) : ('compass.licenses.words.license' | translate)) })"></span>
            </div>
            <div class="container-email-validated-content" *ngIf="assigned_licenses">
                <img src="assets/verified-mail-check.png" [alt]="'compass.licenses.alt.verifiedEmail' | translate">
                <span [innerHTML]="('compass.licenses.notifications.assigned' | translate: { email: assigned_user_email })"></span>
            </div>
            <div class="container-email-validated-content" *ngIf="deleted_licenses">
                <img src="assets/verified-mail-check.png" [alt]="'compass.licenses.alt.verifiedEmail' | translate">
                <span [innerHTML]="('compass.licenses.notifications.deleted' | translate: { email: deleted_user_email })"></span>
            </div>
            <div class="container-email-validated-actions">
                <button (click)="bought_licenses = false; assigned_licenses = false; assigned_user_email = ''; deleted_user_email = ''; deleted_licenses = false">
                    <img class="close-icon" src="assets/boton-x.png" [alt]="'common.buttons.close' | translate">
                </button>
            </div>
        </div>
        <div class="table-container-description" *ngIf="licenses_table.length - licenses_table_assigned.length > 0">
            <p [innerHTML]="('compass.licenses.summarySome' | translate: { total: licenses_table.length, available: (licenses_table.length - licenses_table_assigned.length) })"></p>
        </div>
        <div class="table-container-description" *ngIf="licenses_table.length - licenses_table_assigned.length === 0">
            <p>{{ 'compass.licenses.summaryNone' | translate }}</p>
        </div>
        <div class="table-container-actions"> 
            <div class="table-container-actions-item">
                <button mat-button (click)="goToBuyCompass()">
                    <div class="button-content">
                        <img src="assets/buy-licenses.png" [alt]="'compass.licenses.buyMore' | translate"> 
                        <span>{{ 'compass.licenses.buyMore' | translate }}</span>
                    </div>
                </button>
            </div>  
            <div class="table-container-actions-item" *ngIf="licenses_table.length - licenses_table_assigned.length > 0">
                <button mat-button (click)="addLicense()">
                    <div class="button-content">
                        <span>{{ 'compass.licenses.assignOne' | translate: { available: (licenses_table.length - licenses_table_assigned.length) } }}</span>
                    </div>
                </button>
            </div> 
        </div>
        <div class="table-container">
            <ngx-datatable
            class='table table-hover' [rows]="licenses_table_assigned" [columnMode]="columnModeSetting"
                 [rowHeight]="'auto'" [selected]="selected"
                [scrollbarH]="scrollBarHorizontal" ngSkipHydration>
    
                <div empty-content style="text-align: center; padding:20px" *ngIf="licenses_table_assigned.length === 0">
                    <div class="container-empty-content">
                        <span>{{ 'compass.licenses.empty.title' | translate }}</span>
                        <button mat-button (click)="addLicense()">{{ 'compass.licenses.empty.button' | translate: { available: (licenses_table.length - licenses_table_assigned.length) } }}</button>
                    </div>
                </div>
                <ngx-datatable-column [name]="'compass.licenses.table.name' | translate" prop= "name_customer" cellClass="d-flex align-items-center"  >
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                        {{value ? value : ('compass.licenses.table.notAssigned' | translate)}}
                    </ng-template>
                </ngx-datatable-column>
    
                <ngx-datatable-column [name]="'compass.licenses.table.email' | translate" prop= "assigned_to_mail" cellClass="d-flex align-items-center"   >
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                        <span [ngClass]="{'text-warning': !value}">{{value ? value : ('compass.licenses.table.notAssigned' | translate)}}</span>
                    </ng-template>
                </ngx-datatable-column>
    
                <ngx-datatable-column [name]="'compass.licenses.table.activation' | translate" prop= "creation_subscription_time" cellClass="d-flex align-items-center" >
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                        {{value | date:'dd/MM/yyyy'}}
                    </ng-template>
                </ngx-datatable-column>
                
                <ngx-datatable-column [name]="'compass.licenses.table.renewal' | translate" prop= "end_subscription_time" cellClass="d-flex align-items-center"   >
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                        {{value | date:'dd/MM/yyyy'}}
                    </ng-template>
                </ngx-datatable-column>
    
                <ngx-datatable-column [name]="'compass.licenses.table.action' | translate" cellClass="d-flex align-items-center"  >
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                        <div class="table-actions">
                            <button  (click)="editLicense(row)"><img src="assets/editar-licenses.png" [alt]="'compass.licenses.table.edit' | translate"></button>
                            <button (click)="deleteLicense(row)"><img src="assets/delete-licenses.png" [alt]="'compass.licenses.table.delete' | translate"></button>
                        </div>
    
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>
        </div>
    </div>
    
    <div class="container-help">
        <div class="container-help-title">
            <h2>{{ 'compass.download.title' | translate }}</h2>
        </div>
        <div class="container-chrome-extension-content">
            <img src="assets/chrome-logo.png" [alt]="'compass.download.chromeAlt' | translate" class="chrome-extension-image">
            <a class="chrome-extension-link" href="https://chromewebstore.google.com/detail/conectio/gfacbcmefenjecbijoaknbcenkpmmhjc" target="_blank" rel="noopener noreferrer">{{ 'compass.download.button' | translate }}</a>
        </div>
    </div>
    
    <div class="container-help">
        <div class="container-help-title">
            <h2>{{ 'compass.help.title' | translate }}</h2>
        </div>
        <div class="container-help-content">
            <p [innerHTML]="'compass.help.description' | translate"></p>
            <div class="container-help-content-contact">
                <img src="assets/email.png" alt="Contacto">
                <span>hola&#64;conectio.io</span> 
            </div>
            <div class="container-help-content-contact">
                <img src="assets/whatsapp.png" alt="Contacto">
                <span>(+34) 644 723 402</span>
            </div>
    
            <button mat-button (click)="openContactForm()">{{ 'compass.help.sendForm' | translate }}</button>
        </div>
    </div>
</div>

<div class="loading-container" *ngIf="loading">
    <div class="loading-content">
        <img src="/assets/spinner.gif" alt="Loading" class="loading-gif">
    </div>
</div>